module.exports = __webpack_public_path__ + "static/media/barcode_icon.e7d5c678.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/barcode_icon.svg
// module id = 331
// module chunks = 2